import React, { useState, useEffect } from 'react';
import style from './replica.module.scss';
import thisman from '../../../assets/images/dashboard/adam.jpg'
import { Row, Col, Container, Navbar } from 'react-bootstrap';
import { useParams } from "react-router";
import ProfileService from '../../../service/profile';
import { useHistory } from "react-router-dom";
import { useTranslation, withTranslation } from 'react-i18next';


function Mainguy(props) {
    const { user_name } = useParams();
    const ps = new ProfileService();
    const { t } = useTranslation();
    const history = useHistory();


    return (
        <section id="mainguy" className="plan_cnt_sec_me" >
            <div className="container">
                <div>

                    <Row>
                        <Col md={12} sm={12} className={`${style.mainpaad}`} style={{ "textAlign": "center" }}>
                            {/* <h2 class="heading"> {t('Replica.mypro')} </h2> */}

                            <div className={style.profile_main_sec}>
                                <div className={style.profile_main_img_bx}>
                                    <img src={props.header_data.user_photo} alt="" />
                                </div>
                            </div>

                            <h3 style={{"color" : "white"}}>{user_name}</h3>
                            {
                                props.header_data.country_code === "" || props.header_data.country_code === 0 ?

                                    <div style={{ "marginTop": "10px" }}>
                                       <p style={{"color" : "white"}}> <i style={{"color" : "white"}} class="fa fa-solid fa-phone"></i> {props.header_data.user_details && props.header_data.user_details.phone} </p>
                                    </div>

                                    :
                                    <div style={{ "marginTop": "10px" }}>
                                        <p style={{"color" : "white"}}> <i style={{"color" : "white"}} class="fa fa-solid fa-phone"></i> +{props.header_data.country_code} {props.header_data.user_details && props.header_data.user_details.phone} </p>
                                    </div>

                            }


                            <div style={{ "marginTop": "5px" }}>
                            <p style={{"color" : "white"}}> <i  style={{"color" : "white"}} class="fa fa-regular fa-envelope"></i> {props.header_data.user_details && props.header_data.user_details.email} </p>
                            </div>
                        </Col>
                    </Row>


                </div>

            </div>

        </section>

    )
}

export default Mainguy